<script>
    export let text;
    export let customClass = '';
    export let id = null;
    export let onClick = () => {};
</script>

<!-- <button class="btn btn-outline-success"> -->
<button
    class="custom-btn d-flex align-items-center {customClass}"
    style="border-radius: 100px !important;"
    {id}
    on:click={ onClick }
>
    {#if $$slots.preicon}
        <slot name="preicon" />
    {/if}
    <span class="custom-btn-text pr-3">{text}</span>
    {#if $$slots.posticon}
        <slot name="posticon" />
    {/if}
</button>

<style>
    .custom-btn {
        background-color: transparent;
        color: #31fab1 !important;
        border-color: #31fab1 !important;
        border-radius: 0.25rem;
        border-radius: 100px !important;
        padding: 12px 24px;
    }
    .custom-btn-text {
        font-family: "Inter", sans-serif !important;
        font-weight: bold;
        font-size: 16px;
        padding-right: 0.5rem;
    }
</style>
